<template>
  <button
    type="button"
    :disabled="isDisabled"
    :aria-label="ariaLabel"
    :class="[
      'app-btn',
      isDisabled ? 'disabled' : '',
    ]"
    :style="{
      width: getParsedValue(width),
      height: getParsedValue(height),
      borderRadius: getParsedValue(rounded),
      backgroundColor: background,
      border,
    }"
  >
    <AppLoader
      v-if="isProcessing"
      :size="loaderSize"
      :color="loaderColor"
    />
    <slot v-else />
  </button>
</template>

<script>
export default {
  name: 'AppButton',
  props: {
    width: {
      type: [
        String,
        Number,
      ],
      default: 'auto',
    },
    height: {
      type: [
        String,
        Number,
      ],
      default: '48',
    },
    isProcessing: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    loaderSize: {
      type: [
        Number,
        String,
      ],
      default: '30',
    },
    loaderColor: {
      type: String,
      default: 'white',
    },
    rounded: {
      type: [
        String,
        Number,
      ],
      default: '0',
    },
    ariaLabel: {
      type: String,
      default: 'Button',
    },
    background: {
      type: String,
      default: 'transparent',
    },
    border: {
      type: String,
      default: 'none',
    },
  },
};
</script>

<style lang="scss" scoped>
.app-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  gap: 8px;
  padding: 0 16px !important;
  cursor: pointer;
  padding: 0;

  &:active,
  &:focus {
    outline: none;
  }

  &.disabled {
    cursor: initial;
  }
}
</style>
